// extracted by mini-css-extract-plugin
export var body = "_1r-8";
export var button = "_1r-0";
export var closeButton = "_1r-5";
export var content = "_1r-3";
export var empty = "_1r-f";
export var grid = "_1r-c";
export var header = "_1r-4";
export var icon = "_1r-1";
export var option = "_1r-d";
export var optionSelected = "_1r-e";
export var overlay = "_1r-2";
export var searchIcon = "_1r-a";
export var searchInput = "_1r-b";
export var searchWrapper = "_1r-9";
export var title = "_1r-6";
export var visuallyHidden = "_1r-7";